export { default } from './CercadorFiltres';
